import { AiFillCloseCircle } from "react-icons/ai";
import { useAdmin } from "../../../context/admin";
import GeneralInput from "../../common/GeneralInput";
import Modal from "../../common/Modal";
import { Cost } from "../../../types/common.types";
import { useState } from "react";
import AdminService from "../../../services/admin.service";
import { useGlobal } from "../../../context/global";

export default function CreateCost() {
    const { setMessage, setIsLoading } = useGlobal()
    const { setIsCreateCostModalOpen } = useAdmin()
    const [data, setData] =  useState<Partial<Cost>>({})

    function onChange(e: React.ChangeEvent<HTMLInputElement>) {
        const name = e.target.name
        const value = e.target.value
        setData((prevData) => ({...prevData, [name]: value}))
    }

    async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()
        setIsLoading(true)
        try {
            await AdminService.createCost(data)
            window.location.reload()
        } catch (error) {
            console.log(error)
            setMessage({
                type: 'error',
                content: 'Error creating cost'
            })
            setTimeout(() => setMessage(undefined), 2500)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Modal onSubmit={onSubmit}>
            <h1>Create cost</h1>
            <GeneralInput
            name="name"
            label="Name"
            placeholder="Lunch"
            value={data.name || ''}
            onChange={onChange}
            style={{width: '100%', marginBottom: '15px'}}
            />
            <div className="actions">
                <button type="submit" className="save">Save</button>
            </div>
            <div className="close">
                <AiFillCloseCircle onClick={() => setIsCreateCostModalOpen(false)}/>
            </div>
        </Modal>
    )
}